import {AfterViewInit, Component, HostListener, OnInit, QueryList, ViewChildren, OnDestroy} from '@angular/core';
import {environment} from 'src/environments/environment';
import {FacadeService} from './shared/service-facade/facade.service';
import {NGXLogger, NgxLoggerLevel} from "ngx-logger";
import {LogEvent} from "./shared/model/log-event";
import {SectionStatusService} from "./status-tracker/section-status.service";
import {MatSidenav} from "@angular/material/sidenav";
import {CoreService, PageProps} from './shared/services/core.service';
import {NavigationEnd, NavigationStart, Router} from "@angular/router";
import {
  BANKING_CENTER_ENTRY_PATH,
  BRANCH_PATH,
  CODE_VERIFICATION_PATH,
  ERROR_PATH,
  HOME_PAGE_TITLE,
  HOME_PATH, INVITATION_CREATION_PATH, INVITATION_CREATION_REVIEW_PATH,
  INVITATION_PATH,
  JOINT_MAINTENANCE_PATH,
  MAINTENANCE_PATH,
  PROCESSING_PAGE_TITLE,
  PROCESSING_PATH,
  SOCURE_NAME,
  STYLEGUIDE_PATH,
  SUCCESS_PAGE_TITLE,
  SUCCESS_PATH,
  CREATE_LOGIN_PATH, DOCUMENT_CAPTURE_SERVICE_KEY
} from "./shared/constants";
import {UtilitiesService} from "./shared/services/utilities.service";
import 'hammerjs';
import {ApplicationLogsRequest, Step} from "leia-api";
import StatusEnum = ApplicationLogsRequest.StatusEnum;
import {MatDialog} from "@angular/material/dialog";
import {AbandonReason} from "./shared/model/abandon-reason";
import {ThemeService} from "./core/services/theme.service";
import {SecurityDialogComponent} from "./core/header/dialogs/security-dialog/security-dialog.component";
import {SettingsEnum} from "./shared/model/settings.enum";
import {BehaviorSubject, Observable, Subject} from "rxjs";
import { filter, take, withLatestFrom, map } from "rxjs/operators"
import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs} from "@datadog/browser-logs";
import { MainLayoutService } from './shared/services/main-layout.service';
import { ApplicationIdleService } from './core/services/application-idle.service';
import{ProcessService} from "./process/process.service";
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

//const mParticle = require("@mparticle/web-sdk");

const MANUAL_NAVIGATION_TRIGGER = "popstate";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  isBaskBrand$: Observable<boolean>;
  brandName: string = "";
  isHomePage: boolean | null = null;
  url = "";

  canAccess = UtilitiesService.canRouteInternal;
  isInJointMaintenanceFlow = false;

  idleEnabled : boolean = false;

  lastPing?: Date;
  sessionStarted : any;
  applicationSessionLengthAllowedInMinutes : number = 0;
  isMobile$: Observable<boolean>;
  showStatusTracker$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  create_login_path = `/${CREATE_LOGIN_PATH}`;
  joint_invitation_path = `/${INVITATION_PATH}`;
  title: any;

  get alwaysHideNavForRoutes() {
    return this.url === CODE_VERIFICATION_PATH ||
      this.url === STYLEGUIDE_PATH ||
      this.url === MAINTENANCE_PATH;
  }

  get isCardComponent() {
    return (this.url === ERROR_PATH ||
      this.url === SUCCESS_PATH ||
      window.location.href.includes(INVITATION_PATH)) && !this.isBaskBrand$;
  }

  get isNarrowComponent() {
    return this.url === CODE_VERIFICATION_PATH ||
    this.url === MAINTENANCE_PATH
  }

  get isVerify() {
    return this.url === CODE_VERIFICATION_PATH;
  }

  get isJointAccountMaintenancePath() {
    return this.url === JOINT_MAINTENANCE_PATH
  }

  get isNarrowJointComponent() {
    return window.location.href.includes(INVITATION_PATH)
      || window.location.href.includes(INVITATION_CREATION_PATH)
      || window.location.href.includes(INVITATION_CREATION_REVIEW_PATH);
  }

  isInJointMaintenanceFlow$: BehaviorSubject<boolean>;

  get isBankingCenter() {
    return this.url === BANKING_CENTER_ENTRY_PATH ||
      this.url === BRANCH_PATH;
  }

  get isEmployeeBenefit() {
    if(this.router.url == '/employee-benefit/products' || this.router.url == '/employee-benefit/access') {
      return true;
    }

    return false;
  }

  private destroySubject: Subject<void> = new Subject();

  showSuccessTracker$: Observable<boolean>;
  trackingUrl$: BehaviorSubject<SafeUrl | undefined> = new BehaviorSubject<SafeUrl | undefined>(undefined);

  @ViewChildren(MatSidenav) sidenav!: QueryList<MatSidenav>;


  constructor(private facadeService: FacadeService,
              public coreService: CoreService,
              private logger: NGXLogger,
              public dialog: MatDialog,
              private statusTrackerService: SectionStatusService,
              private utils: UtilitiesService,
              public router: Router,
              public applicationIdleService: ApplicationIdleService,
              private readonly themeService: ThemeService,
              public mainLayout: MainLayoutService,
              public processService: ProcessService,
              private _domSanitizer: DomSanitizer
  ) {
    this.showSuccessTracker$ = this.facadeService.showSuccessTracker$.pipe(
      withLatestFrom(this.trackingUrl$),
      filter(([showSuccess, url]) => typeof url !== "undefined"),
      take(1),
      map(([showSuccess, url]) => showSuccess)
    );

    this.facadeService.isInJointMaintenanceFlow$.subscribe(value => {
      this.isInJointMaintenanceFlow = value;
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationStart)
    ).subscribe(event => {
      // If navigation occured via the back or foward browser buttons, we set a flag
      // that can be checked via the core service
      const navigationTrigger = (event as NavigationStart).navigationTrigger;
      if (navigationTrigger === MANUAL_NAVIGATION_TRIGGER) {
        this.coreService.isManualNavigation = true;
        UtilitiesService.canRouteInternal = true;
        this.coreService.backButtonClicked.emit();
      }
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(event => {
      const fullUrl = (event as NavigationEnd).url;

      if (!fullUrl) {
        return;
      }

      const url = fullUrl.substring(1);

      if (url === PROCESSING_PATH && this.isInJointMaintenanceFlow) {
        this.showStatusTracker$.next(true);
        return;
      }

      this.showStatusTracker$.next(
        this.statusTrackerService.sectionsWithStatusTracker.includes(url)
      );
    });

    this.facadeService.setDeviceType();

    this.isMobile$ = this.facadeService.isMobile$;
    this.isInJointMaintenanceFlow$ = this.facadeService.isInJointMaintenanceFlow$;
    this.isBaskBrand$ = this.facadeService.isBaskBrand$;
  }

  gtmScriptInit() {
    const gtmScript = document.createElement('script');
    gtmScript.type = 'text/javascript';
    gtmScript.innerHTML = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-56JVTQQ');";
    document.head.appendChild(gtmScript);
  }

  cdpScriptInit() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = this.brandName === 'Bask Bank' ? environment.cdpBaskSrc : environment.cdpTcbSrc;
    document.head.appendChild(script);
  }

  ngOnInit() {
    this.themeService.setBaseTheme(true);

    this.sessionStarted = Date.now();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.url = event.url.split("/")[1];
        this.setPageProperties(this.url);

        if(!this.idleEnabled) {
          if(!this.url.startsWith(SOCURE_NAME)) {
            this.idleEnabled = true;

            this.facadeService.globalSettingsLoaded.subscribe(loaded => {
              if (!loaded) { return; }

              this.applicationSessionLengthAllowedInMinutes = parseInt(this.facadeService.getStorageItem("application-time-length-max-minutes"));
            });

            //Loads GTM scripts for non-product pages
            if(this.isBankingCenter) {
              //comment mParticle, CDP scripts are live, remove the code later
              //this.mParticleDataInit();
              const consentRejected = document.cookie.split(';').some(c => c.trim().startsWith('consentRejected='));
              if (!consentRejected) {
                this.gtmScriptInit();
              }
            }
          }
        }
      }

      if (event instanceof NavigationEnd) {
        UtilitiesService.canRouteInternal = false;
      }
    });

    // subscribe to brand name changes and pass to welcome component
    this.coreService.brandNameSubject.subscribe(brandName => this.brandName = brandName);

    //Add CDP script tags (Salesforce Interaction Studio / Evergage)
    // Skip if user has rejected consent — this script sets _sfid_* tracking cookies
    const consentRejected = document.cookie.split(';').some(c => c.trim().startsWith('consentRejected='));
    if (!consentRejected) {
      this.cdpScriptInit();
    }

    this.coreService.canAccessSubject.subscribe(canAccess => {
      this.canAccess = canAccess;
    });

    window.addEventListener('DOMContentLoaded', function() {
      let deviceFPOptions = {
        publicKey: environment.socureSdkKey,
        endpoint: environment.socureDeviceRiskEndpoint,
        userConsent: true,
        context: 'signup',
      }

      // @ts-ignore
      devicer.run(deviceFPOptions, function(response : any) {
        if(environment.development || environment.local) console.warn('deviceRisk response: ' + JSON.stringify(response));
        UtilitiesService.deviceRiskSessionId = response.sessionId;
      });
    });

    this.dataDogInit();

    this._setupTracking();
  }

  ngOnDestroy(): void {
    datadogRum.stopSessionReplayRecording();
    datadogRum.clearUser();
  }


  private _setupTracking(): void {
    const trackingURL = this.facadeService.getStorageItem(SettingsEnum.SuccessTrackingURL);

    if (trackingURL) {
      this.trackingUrl$.next(this._domSanitizer.bypassSecurityTrustUrl(trackingURL));
    }
  }

  dataDogInit() : void {
    datadogRum.init({
      applicationId: environment.dataDogApplicationId,
      clientToken: environment.dataDogClientToken,
      service: environment.dataDogService,
      env: environment.env,
      sampleRate: 100,
      sessionReplaySampleRate: 100,
      trackResources: true,
      trackLongTasks: true,
      trackInteractions: true,
      useCrossSiteSessionCookie: true
    });

    datadogLogs.init({
      clientToken: environment.dataDogClientToken,
      service: environment.dataDogService,
      env: environment.env,
      forwardErrorsToLogs: true,
      forwardConsoleLogs: "all",
      sampleRate: 100
    });

    datadogRum.startSessionReplayRecording();
  }

  //comment mParticle, CDP scripts are live, remove the code later
  // mParticleDataInit(): void {
  //   let mParticleConfig = {
  //     isDevelopmentMode: !environment.production,
  //     useCookieStorage: true,
  //     identityCallback: function({result}: { result: any }) {
  //       // Do something once an identity call has been made.
  //       // For more information, see https://docs.mparticle.com/developers/sdk/web/idsync/#sdk-initialization-and-identify
  //       console.log(result);
  //     },
  //   };
  //   mParticle.default.init(environment.mParticleKey, mParticleConfig);
  // }

  private setPageProperties(path: string): void {
    switch (path) {
      case HOME_PATH:
        this.setHomePageProps();
        break;
      case PROCESSING_PATH:
        this.setProcessingPageProps();
        break;
      case SUCCESS_PATH:
        this.setSuccessPageProps();
        break;
      case CODE_VERIFICATION_PATH:
        this.setVerifyPageProps();
        break;
      case MAINTENANCE_PATH:
        this.setMaintenancePageProps();
        break;
      case BRANCH_PATH:
        this.setBranchPageProps();
        break;
      case ERROR_PATH:
        this.setErrorPageProps();
    }
  }

  ngAfterViewInit(): void {
    this.statusTrackerService.sideNavDisplayChange
      .subscribe(
        (sideNavShow: boolean) => {
          const sideNavRef = this.sidenav.get(0);
          if (sideNavShow) {
            sideNavRef?.open();
          } else {
            sideNavRef?.close();
          }
        }
      );


  }

  private setMaintenancePageProps(): void {
    const props = new PageProps();
    props.title = "";
    props.isHomePage = false;

    this.coreService.setPageProps(props);
  }

  private setVerifyPageProps(): void {
    const props = new PageProps();
    props.title = "";
    props.isHomePage = false;

    this.coreService.setPageProps(props);
  }

  private setErrorPageProps(): void {
    const props = new PageProps();
    props.title = '';
    props.isHomePage = false;

    this.coreService.setPageProps(props);
  }

  private setSuccessPageProps(): void {
    const props = new PageProps();
    props.title = SUCCESS_PAGE_TITLE.replace("{firstname}", this.facadeService.getNewAccountInformation()?.firstName);
    props.isHomePage = false;

    this.coreService.setPageProps(props);
  }

  private setHomePageProps(): void {
    const props = new PageProps();
    props.title = HOME_PAGE_TITLE;
    props.isHomePage = true;
    this.coreService.setPageProps(props);

    this.isHomePage = props.isHomePage;
  }

  private setBranchPageProps(): void {
    this.themeService.setBaseTheme();
  }

  private setProcessingPageProps(): void {
    const props = new PageProps();
    props.title = PROCESSING_PAGE_TITLE;
    props.isHomePage = false;
    this.coreService.setPageProps(props);
  }

  /**
   * Updates the logger config to the new log level
   * @param newLevel
   */
  handleLogLevelChange(newLevel: NgxLoggerLevel) {
    const updatedConfig = this.logger.getConfigSnapshot();
    updatedConfig.level = newLevel;
    updatedConfig.serverLogLevel = newLevel;
    this.logger.updateConfig(updatedConfig);
  }

  /**
   * Logs the user input using NGXLogger
   * @param log
   */
  handleLog(log: LogEvent) {
    switch (log.logType) {
      case NgxLoggerLevel.TRACE:
        this.logger.trace(log.logMessage);
        break;
      case NgxLoggerLevel.DEBUG:
        this.logger.debug(log.logMessage);
        break;
      case NgxLoggerLevel.INFO:
        this.logger.info(log.logMessage);
        break;
      case NgxLoggerLevel.LOG:
        this.logger.log(log.logMessage);
        break;
      case NgxLoggerLevel.WARN:
        this.logger.warn(log.logMessage);
        break;
      case NgxLoggerLevel.ERROR:
        this.logger.error(log.logMessage);
        break;
      case NgxLoggerLevel.FATAL:
        this.logger.fatal(log.logMessage);
        break;
    }
  }

  handleDisableFileDetails(disableFileDetails: boolean) {
    const updatedConfig = this.logger.getConfigSnapshot();
    updatedConfig.disableFileDetails = disableFileDetails;
    this.logger.updateConfig(updatedConfig);
  }

  serverLogging(enabled: boolean) {
    const updatedConfig = this.logger.getConfigSnapshot();
    updatedConfig.serverLoggingUrl = enabled ? '/dummyURL' : undefined;
    this.logger.updateConfig(updatedConfig);
  }

  loadHeaderScript(type: string, async: boolean, source: string, value: string) {
    // set the script values
    const script = document.createElement('script');
    script.type = type//'text/javascript';
    script.async = async;//true;
    script.src = source;

    // append any dynamic value at the end
    if (value.length) {
      script.src += value;
    }

    const head = document.getElementsByTagName('head')[0];
    if (head !== null && head !== undefined) {
      document.head.appendChild(script);
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  async checkBeforeUnloading($event : any) {
    $event.preventDefault();
    let {url} = this.router;

    if(url.includes(this.joint_invitation_path))
      return null;

    if(!url.includes(this.create_login_path)) {
      await this.facadeService.abandonApplicationIfNeeded(AbandonReason.Unload);
    } else {
      await this.facadeService.updateApplicationInOLBCredentialsPage();
    }
    return null;
  }

  @HostListener('window:mousemove')
  async mouseMoveActivity() {
    await this.detectActivity();
  }
  @HostListener('window:keydown')
  async keydownActivity() {
    await this.detectActivity();
  }
  @HostListener('window:onscroll')
  async scrollActivity() {
    await this.detectActivity();
  }
  @HostListener('window:touchstart')
  async touchActivity() {
    await this.detectActivity();
  }

  async detectActivity() {
    if (this.applicationIdleService.isApplicationAbandoned) return;

    let time = Date.now();
    let timeDifference = time - this.sessionStarted;
    let minutes = Math.floor(timeDifference / 60000);
    if (this.applicationSessionLengthAllowedInMinutes > 0 && minutes >= this.applicationSessionLengthAllowedInMinutes) {
      if (this.isApplicationInFinishedState()) {
        const { cancelUrl } = this.facadeService.getSuccessConfiguration();
        window.location.href = cancelUrl;
        return;
      }

      let cancelUrl = this.facadeService.getStorageItem(SettingsEnum.CancelUrl);
      if (this.facadeService.isFromBranch())
        cancelUrl = this.facadeService.getStorageItem(SettingsEnum.BranchCancelUrl)

      let {url} = this.router;
      if (url.includes(this.create_login_path)) {
        await this.facadeService.updateApplicationInOLBCredentialsPage();

        // clear storage when leaving the app
        this.facadeService.clearStorage();
        this.facadeService.clearAllCookies();
        window.location.href = cancelUrl;
        return;
      }

      // Okta Token could have expired so lets get a fresh token before calling Leia.
      try {
        await this.facadeService.abandonApplicationIfNeeded(AbandonReason.MaxTime);
        this.applicationIdleService.markApplicationAsAbandoned();
      } catch (e) {
        this.facadeService.clearStorage();
        this.facadeService.clearAllCookies();
        window.location.href = cancelUrl;
        return;
      }
    }
  }

  isApplicationInFinishedState() : boolean {
    const applicationRequest = this.facadeService.getShoppingCartApplicationLogsRequest();

    if (applicationRequest.status === StatusEnum.Approved || applicationRequest.status === StatusEnum.Rejected || applicationRequest.status === StatusEnum.UnderReview) return true;

    return false;
  }

  openDialog() {
    const dialogRef = this.dialog.open(SecurityDialogComponent, {
      panelClass: 'popup-dialog',
      width: '100%',
      maxWidth: '664px',
      disableClose: true,
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe(async userRequestsCancel => {
      if (!userRequestsCancel) return;
    });

  }
}
